export default "__VITE_ASSET__DjccnnRT__"